import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { useStyles } from './styles/stylesCard';

const CardComponent = ({ title, table }) => {

    const classes = useStyles();
    
    return (
        <Card className={classes.root}>
            <CardContent className={classes.content}>
                { title }
                <div className="table">
                    { table }
                </div>
            </CardContent>
        </Card>
    );
}
 
export default CardComponent;